import React, { useEffect, useRef, useState } from "react";
import { startDrone } from "../../lib/scaleCountryAudio";

/* ============================================================
   DroneButton — a held root-note drone to wander a scale over.
   Cleans itself up on unmount so switching pages never leaves a
   note ringing in the background.
   ============================================================ */

const DroneButton = () => {
  const [on, setOn] = useState(false);
  const droneRef = useRef(null);

  useEffect(() => {
    return () => {
      droneRef.current?.stop();
      droneRef.current = null;
    };
  }, []);

  const toggle = () => {
    if (on) {
      droneRef.current?.stop();
      droneRef.current = null;
      setOn(false);
    } else {
      droneRef.current = startDrone(48);
      setOn(true);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={on}
      aria-label={on ? "stop drone" : "start drone"}
      className={`rounded-md border border-[#45523F] px-4 py-2 font-mono text-xs tracking-wide uppercase transition-colors hover:border-[#A6C46A] ${
        on ? "bg-[#A6C46A] font-bold text-[#1B221A]" : "text-[#E9EDDC]"
      }`}
    >
      {on ? "DRONE ●" : "DRONE ○"}
    </button>
  );
};

export default DroneButton;
